import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=65fb0996&scoped=true&"
import script from "./Banks.vue?vue&type=script&lang=js&"
export * from "./Banks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb0996",
  null
  
)

export default component.exports